"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOnyxiaSplashScreenLogo = exports.createSplashScreen = exports.useSplashScreen = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var color_1 = __importDefault(require("color"));
var hooks_1 = require("evt/hooks");
var useGlobalState_1 = require("powerhooks/useGlobalState");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var compat_1 = require("tss-react/compat");
var evt_1 = require("evt");
var id_1 = require("tsafe/id");
var useGuaranteedMemo_1 = require("powerhooks/useGuaranteedMemo");
var runExclusive = __importStar(require("run-exclusive"));
var OnyxiaLogo_1 = require("../assets/svg/OnyxiaLogo");
var useConst_1 = require("powerhooks/useConst");
var ViewPortAdapter_1 = require("powerhooks/ViewPortAdapter");
var fadeOutDuration = 700;
var minimumDisplayDuration = 1000;
var _a = (function () {
    var evtDisplayState = evt_1.Evt.create({
        "count": 1,
        "isTransparencyEnabled": false,
        "prevTime": 0,
        "onHiddens": id_1.id([]),
    });
    var globalHideSplashScreen = (function () {
        var getDoUseDelay = (function () {
            var evtLastDelayedTime = useGlobalState_1.createUseGlobalState({
                "name": "lastDelayedTime",
                "initialState": 0,
                "doPersistAcrossReloads": true,
            }).evtLastDelayedTime;
            function getDoUseDelay() {
                var doUseDelay = Date.now() - evtLastDelayedTime.state > 30000;
                if (doUseDelay) {
                    evtLastDelayedTime.state = Date.now();
                }
                return doUseDelay;
            }
            return { getDoUseDelay: getDoUseDelay };
        })().getDoUseDelay;
        var next = runExclusive.build(function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getDoUseDelay()) return [3 /*break*/, 2];
                        return [4 /*yield*/, new Promise(function (resolve) {
                                return setTimeout(resolve, minimumDisplayDuration);
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        evtDisplayState.state = __assign(__assign({}, evtDisplayState.state), { "prevTime": Date.now() });
                        return [2 /*return*/];
                }
            });
        }); });
        function globalHideSplashScreen() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    evtDisplayState.state.count = Math.max(evtDisplayState.state.count - 1, 0);
                    if (runExclusive.isRunning(next)) {
                        return [2 /*return*/];
                    }
                    next();
                    return [2 /*return*/];
                });
            });
        }
        return { globalHideSplashScreen: globalHideSplashScreen };
    })().globalHideSplashScreen;
    function globalShowSplashScreen(params) {
        evtDisplayState.state = {
            "count": evtDisplayState.state.count + 1,
            "isTransparencyEnabled": params.enableTransparency,
            "prevTime": Date.now(),
            "onHiddens": [],
        };
    }
    function useSplashScreenStatusInternal() {
        hooks_1.useRerenderOnStateChange(evtDisplayState);
        var _a = useGuaranteedMemo_1.useGuaranteedMemo(function () { return ({
            "isSplashScreenShown": evtDisplayState.state.count > 0,
            "isTransparencyEnabled": evtDisplayState.state.isTransparencyEnabled,
        }); }, [evtDisplayState.state]), isSplashScreenShown = _a.isSplashScreenShown, isTransparencyEnabled = _a.isTransparencyEnabled;
        return {
            isSplashScreenShown: isSplashScreenShown,
            isTransparencyEnabled: isTransparencyEnabled,
        };
    }
    function useSplashScreen(params) {
        if ((params === null || params === void 0 ? void 0 : params.fadeOutDuration) !== undefined) {
            fadeOutDuration = params.fadeOutDuration;
        }
        if ((params === null || params === void 0 ? void 0 : params.minimumDisplayDuration) !== undefined) {
            minimumDisplayDuration = params.minimumDisplayDuration;
        }
        var isUsingSplashScreen = react_1.useContext(context);
        react_1.useEffect(function () {
            var onHidden = (params !== null && params !== void 0 ? params : {}).onHidden;
            if (onHidden === undefined) {
                return;
            }
            if (!isUsingSplashScreen) {
                onHidden();
                return;
            }
            evtDisplayState.state.onHiddens.push(onHidden);
        }, []);
        var _a = (function useClosure() {
            var _this = this;
            var countRef = react_1.useRef(0);
            var showSplashScreen = useConstCallback_1.useConstCallback(function (_a) {
                var enableTransparency = _a.enableTransparency;
                countRef.current++;
                globalShowSplashScreen({ enableTransparency: enableTransparency });
            });
            var hideSplashScreen = useConstCallback_1.useConstCallback(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (countRef.current === 0) {
                                return [2 /*return*/];
                            }
                            countRef.current--;
                            return [4 /*yield*/, globalHideSplashScreen()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
            return { showSplashScreen: showSplashScreen, hideSplashScreen: hideSplashScreen };
        })(), showSplashScreen = _a.showSplashScreen, hideSplashScreen = _a.hideSplashScreen;
        var _b = useSplashScreenStatusInternal(), isSplashScreenShown = _b.isSplashScreenShown, isTransparencyEnabled = _b.isTransparencyEnabled;
        return {
            isSplashScreenShown: isSplashScreenShown,
            isTransparencyEnabled: isTransparencyEnabled,
            "hideRootSplashScreen": globalHideSplashScreen,
            showSplashScreen: showSplashScreen,
            hideSplashScreen: hideSplashScreen,
        };
    }
    function useSplashScreenStatus() {
        var _this = this;
        var _a = useSplashScreenStatusInternal(), isSplashScreenShown = _a.isSplashScreenShown, isTransparencyEnabled = _a.isTransparencyEnabled;
        react_1.useEffect(function () {
            var _a;
            if (isSplashScreenShown) {
                return;
            }
            var delayLeft = (_a = [
                fadeOutDuration -
                    (Date.now() - evtDisplayState.state.prevTime),
            ].filter(function (v) { return v > 0; })[0]) !== null && _a !== void 0 ? _a : 0;
            var timer;
            (function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, new Promise(function (resolve) { return (timer = setTimeout(resolve, delayLeft)); })];
                        case 1:
                            _a.sent();
                            evtDisplayState.state.onHiddens.forEach(function (onHidden) { return onHidden(); });
                            evtDisplayState.state.onHiddens = [];
                            return [2 /*return*/];
                    }
                });
            }); })();
            return function () { return clearTimeout(timer); };
        }, [isSplashScreenShown]);
        return { isSplashScreenShown: isSplashScreenShown, isTransparencyEnabled: isTransparencyEnabled };
    }
    return { useSplashScreen: useSplashScreen, useSplashScreenStatus: useSplashScreenStatus };
})(), useSplashScreen = _a.useSplashScreen, useSplashScreenStatus = _a.useSplashScreenStatus;
exports.useSplashScreen = useSplashScreen;
var context = react_1.createContext(false);
function createSplashScreen(params) {
    var useTheme = params.useTheme;
    var makeStyles = compat_1.createMakeStyles({ useTheme: useTheme }).makeStyles;
    function SplashScreen(props) {
        var _this = this;
        var children = props.children, Logo = props.Logo;
        if ((props === null || props === void 0 ? void 0 : props.fadeOutDuration) !== undefined) {
            fadeOutDuration = props.fadeOutDuration;
        }
        if ((props === null || props === void 0 ? void 0 : props.minimumDisplayDuration) !== undefined) {
            minimumDisplayDuration = props.minimumDisplayDuration;
        }
        var _a = useSplashScreenStatus(), isSplashScreenShown = _a.isSplashScreenShown, isTransparencyEnabled = _a.isTransparencyEnabled;
        {
            var defaultOverflow_1 = useConst_1.useConst(function () { return document.body.style.overflow; });
            react_1.useEffect(function () {
                document.body.style.overflow = isSplashScreenShown
                    ? "hidden"
                    : defaultOverflow_1;
            }, [isSplashScreenShown]);
        }
        var _b = __read(react_1.useState(false), 2), isFadingOut = _b[0], setIsFadingOut = _b[1];
        var _c = __read(react_1.useState(true), 2), isVisible = _c[0], setIsVisible = _c[1];
        var isViewPortAdapterEnabled = (function useClosure() {
            var viewPortState = ViewPortAdapter_1.useViewPortState().viewPortState;
            var isViewPortAdapterEnabled = viewPortState !== undefined;
            return { isViewPortAdapterEnabled: isViewPortAdapterEnabled };
        })().isViewPortAdapterEnabled;
        var classes = useStyles({
            isVisible: isVisible,
            isFadingOut: isFadingOut,
            isTransparencyEnabled: isTransparencyEnabled,
            isViewPortAdapterEnabled: isViewPortAdapterEnabled,
        }).classes;
        react_1.useEffect(function () {
            var timer = setTimeout(function () {
                /* No action */
            }, 0);
            (function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!isSplashScreenShown) return [3 /*break*/, 1];
                            setIsFadingOut(false);
                            setIsVisible(true);
                            return [3 /*break*/, 3];
                        case 1:
                            setIsFadingOut(true);
                            return [4 /*yield*/, new Promise(function (resolve) {
                                    return (timer = setTimeout(resolve, fadeOutDuration));
                                })];
                        case 2:
                            _a.sent();
                            setIsFadingOut(false);
                            setIsVisible(false);
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
            return function () { return clearTimeout(timer); };
        }, [isSplashScreenShown]);
        return (jsx_runtime_1.jsxs(context.Provider, __assign({ value: true }, { children: [jsx_runtime_1.jsx("div", __assign({ className: classes.root }, { children: jsx_runtime_1.jsx(Logo, {}, void 0) }), void 0), children] }), void 0));
    }
    var useStyles = makeStyles({ "name": { SplashScreen: SplashScreen } })(function (theme, _a) {
        var isVisible = _a.isVisible, isFadingOut = _a.isFadingOut, isTransparencyEnabled = _a.isTransparencyEnabled, isViewPortAdapterEnabled = _a.isViewPortAdapterEnabled;
        return ({
            "root": {
                "width": "100%",
                "height": isViewPortAdapterEnabled ? "100%" : "100vh",
                "position": "fixed",
                "top": 0,
                "left": 0,
                "zIndex": 10,
                "backgroundColor": (function () {
                    var color = new color_1.default(theme.colors.useCases.surfaces.background).rgb();
                    return color
                        .alpha(isTransparencyEnabled ? 0.6 : color.valpha)
                        .string();
                })(),
                "backdropFilter": isTransparencyEnabled
                    ? "blur(10px)"
                    : undefined,
                "display": "flex",
                "alignItems": "center",
                "justifyContent": "center",
                "visibility": isVisible ? "visible" : "hidden",
                "opacity": isFadingOut ? 0 : 1,
                "transition": "opacity ease-in-out " + fadeOutDuration + "ms",
            },
        });
    });
    return { SplashScreen: SplashScreen };
}
exports.createSplashScreen = createSplashScreen;
/**
 * You have to create your own version of this component
 * you are expected to size it in percentage.
 */
function createOnyxiaSplashScreenLogo(params) {
    var useTheme = params.useTheme;
    var makeStyles = compat_1.createMakeStyles({ useTheme: useTheme }).makeStyles;
    var OnyxiaSplashScreenLogo = react_1.memo(function () {
        var classes = useStyles().classes;
        return jsx_runtime_1.jsx(OnyxiaLogo_1.OnyxiaLogoSvg, { className: classes.root }, void 0);
    });
    var useStyles = makeStyles({ "name": { OnyxiaSplashScreenLogo: OnyxiaSplashScreenLogo } })(function (theme) { return ({
        "root": {
            "height": "20%",
            "fill": theme.colors.useCases.typography.textFocus,
            "& g": {
                "opacity": 0,
                "animation": compat_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                            60%, 100% {\n                                opacity: 0;\n                            }\n                            0% {\n                                opacity: 0;\n                            }\n                            40% {\n                                opacity: 1;\n                            }\n                            "], ["\n                            60%, 100% {\n                                opacity: 0;\n                            }\n                            0% {\n                                opacity: 0;\n                            }\n                            40% {\n                                opacity: 1;\n                            }\n                            "]))) + " 3.5s infinite ease-in-out",
                "&:nth-of-type(1)": {
                    "animationDelay": ".4s",
                },
                "&:nth-of-type(2)": {
                    "animationDelay": ".8s",
                },
                "&:nth-of-type(3)": {
                    "animationDelay": "1.2s",
                },
            },
        },
    }); });
    return { OnyxiaSplashScreenLogo: OnyxiaSplashScreenLogo };
}
exports.createOnyxiaSplashScreenLogo = createOnyxiaSplashScreenLogo;
var templateObject_1;
//# sourceMappingURL=SplashScreen.js.map